<template>
  <div class="hm-link">
    {{value.cta.desc}}
  </div>
</template>
<script>
import config from './config'
export default {
  name: "HmLink",
  wgtName: 'HmLink',
  wgtDesc: 'hmLink',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
}
</script>
<style scoped lang="scss">
.hm-link{
  padding: 0 16px 16px;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #000;
  background: white;
}
</style>
